<div class="modal-header">
  <h4 class="modal-title pull-left" i18n>{{ title }}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-container *ngIf="!isDocumentPreview" i18n>{{ body }}</ng-container>
</div>
<div class="modal-footer">
  <button
    *ngIf="isConfirm"
    type="button"
    class="btn btn-primary btn-red"
    (click)="confirm()"
    i18n="@@Confirm"
  >
    Confirm
  </button>
  <button
    *ngIf="isConfirm"
    type="button"
    class="btn btn-secondary"
    (click)="bsModalRef.hide()"
    i18n="@@Cancel"
  >
    Cancel
  </button>
</div>
